export enum LookupStatusType {
  SUCCESS = "success", ERROR = "error", IGNORE = ""
}
